import styled, { css } from "styled-components";

export const Overlay = styled.div`
  ${(p) =>
    p.$isFullscreen
      ? css`
          position: fixed;
          inset: 0;
        `
      : p.$fixedRect
      ? css`
          position: fixed;
          top: ${p.$fixedRect.top}px;
          left: ${p.$fixedRect.left}px;
          width: ${p.$fixedRect.width}px;
          height: ${p.$fixedRect.height}px;
        `
      : css`
          position: absolute; /* requer pai com position: relative */
          inset: 0;
        `}

  z-index: ${(p) => p.$zIndex};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 16px;

  background: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(${(p) => p.$blur});
  -webkit-backdrop-filter: blur(${(p) => p.$blur});
  pointer-events: auto;
  cursor: default;
  user-select: none;
`;

export const Card = styled.div`
  pointer-events: none;
  display: flex;
  flex-direction: column;
  max-width: 520px;
  width: 100%;
  gap: 12px;
  text-align: center;
  border-radius: 20px;
  padding: 24px 20px;
  color: #fff;
  align-items: center;

  @media (prefers-color-scheme: light) {
    background: rgba(255, 255, 255, 0.85);
    color: #101216;
    border: 1px solid rgba(0, 0, 0, 0.06);
  }
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
`;

export const Subtitle = styled.div`
  margin-top: 8px;
  font-size: 14px;
  opacity: 0.9;
`;
